import React from 'react';

import SmartlinkEditor from '../../admin/smartlinks/smartlink-editor';

import './smartlink-editor-modal.scss';

const SmartlinkModal = ({ smartlinkId, toggleModal }) => {
  return (
    <div className="smartlink-editor-modal">
      <div className="modal-container">
        <SmartlinkEditor smartlinkId={smartlinkId} modalView={true} toggleModal={toggleModal} />
      </div>
    </div>
  );
};

export default SmartlinkModal;
